import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { ProductTaxDetail } from '../types';

interface ProductHeaderProps {
  product: ProductTaxDetail;
  onExport: () => void;
  onClose: () => void;
}

const ProductHeader = ({ product, onExport, onClose }: ProductHeaderProps) => {
  const getDataSourceBadge = () => {
    if (product.dataSource === 'api') {
      return (
        <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-success/10 text-success text-xs font-medium rounded-full">
          <Icon name="Zap" size={12} />
          API Gestor Tributário
        </span>
      );
    }
    return (
      <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-warning/10 text-warning text-xs font-medium rounded-full">
        <Icon name="Edit" size={12} />
        Entrada Manual
      </span>
    );
  };

  return (
    <div className="border-b border-border bg-card">
      <div className="p-6">
        <div className="flex items-start justify-between gap-4 mb-4">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-2">
              <h1 className="text-2xl font-bold text-foreground">{product.name}</h1>
              {getDataSourceBadge()}
            </div>
            <p className="text-sm text-muted-foreground mb-3">{product.description}</p>
            <div className="flex items-center gap-4 text-sm">
              <div className="flex items-center gap-2">
                <span className="text-muted-foreground">Código:</span>
                <span className="font-mono font-semibold text-foreground">{product.code}</span>
              </div>
              <div className="w-px h-4 bg-border"></div>
              <div className="flex items-center gap-2">
                <span className="text-muted-foreground">NCM:</span>
                <span className="font-mono font-semibold text-foreground">{product.ncm}</span>
              </div>
              {product.cest && (
                <>
                  <div className="w-px h-4 bg-border"></div>
                  <div className="flex items-center gap-2">
                    <span className="text-muted-foreground">CEST:</span>
                    <span className="font-mono font-semibold text-foreground">{product.cest}</span>
                  </div>
                </>
              )}
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-md transition-colors"
            aria-label="Fechar"
          >
            <Icon name="X" size={20} color="var(--color-muted-foreground)" />
          </button>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2">
              <Icon name="Tag" size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm text-muted-foreground">Categoria:</span>
              <span className="text-sm font-medium text-foreground">{product.category}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Clock" size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm text-muted-foreground">Atualizado:</span>
              <span className="text-sm font-medium text-foreground">
                {new Date(product.lastUpdated).toLocaleDateString('pt-BR', {
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric'
                })}
              </span>
            </div>
          </div>

          <Button variant="outline" iconName="Download" iconPosition="left" onClick={onExport}>
            Exportar Detalhes
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProductHeader;